const product = {
  hu: {
    "Sold capacity":
      "A termelési kapacitások erre az évre megteltek.<br>Köszönjük!",
    Sold: "Eladott",
    Alright: "Rendben",
    illustration_popup_description_1:
      "Az Ön fényképét szerkesztjük és átrajzoljuk az Ön által választott stílusban.",
    illustration_popup_description_2:
      "Az átrajzolt fényképet a megrendeléstől számított 24 órán belül elküldjük Önnek jóváhagyásra.",
    illustration_popup_description_3:
      "A rajz jóváhagyása után az üveglap azonnal gyártásba kerül.",
    "Active stories": "Aktív történetek",
    "Liked photo": "Belájkolt kép",
    "Approved account": "Hitelesített fiók",
    "And others": "És további",
    "Like it": "Kedvelte",
    Description: "Leírás",
    required_field: "Pole {name} je povinné",
    "Upload image": "Kép feltöltése",
    "Upload photo": "Kép feltöltése {number}",
    "Choose shape": "Válassz arc",
    "Choose theme": "Válassz motívumot",
    Date: "Dátum",
    "Names + Dates": "Neveket + Dátum",
    Names: "Neveket",
    "Choose template color": "Válaszd ki a sablon színét",
    rotate_glass: "Üvegtábla elforgatása vízszintes helyzetbe",
    "Choose table size": "Válaszd ki az üvegtábla méretét",
    "Choose stand": "Válaszd ki az állványt",
    "Choose packaging": "Ajándékcsomagolás hozzáadása",
    "Add table to cart": "Üvegtábla hozzáadása a kosárhoz",
    "No stand": "Állvány nélkül",
    "Acryl stand": "Akril állvány",
    "Wooden stand": "Fa állvány",
    "Black oak massif": "Fekete fa állvány",
    "Brown oak massif": "Barna fa állvány",
    "Engraved oak massif": "Fa állvány gravírozással",
    "Stand text placeholder":
      "A fa állványon szereplő szöveg (max. {limit} karakter)",
    White: "Fehér",
    Black: "Fekete",
    Original: "Eredetiség",
    Save: "Mentés",
    Edit: "Szerkeszés",
    Delete: "Eltávolítás",
    "Uploaded image": "Feltöltött kép",
    image_loading:
      "Folyamatban van a kép feltöltése.<br>Ez eltarthat egy darabig.",
    Stand: "Állvány",
    "Horizontal rotation": "Vízszintes forgatás",
    LoverType: "Motívum",
    "Magnetic mounts": "Mágneses rögzítés falra",
    "Luminous oak massif": "Világító fa állvány",
    product_description:
      "*A plakett üvegből készül. A színes háttér csak a könnyebb szerkesztést szolgálja. Az előnézet szemléltető jellegű. A gyártás előtt korrigáljuk az esetleges hibákat.",
    "Add text": "Szöveg hozzáadása",
    "Primary text": "Szöveg",
    "Secondary text": "Kiegészítő szöveg",
    "Add secondary text": "Kiegészítő szöveg hozzáadása",
    "Add secondary text max":
      "Kiegészítő szöveg hozzáadása (max. 150 karakter)",
    "Carefully check data":
      "Kérjük, gondosan ellenőrizze az összes beírt szöveget és adatot.",
    "Song name": "Dal címe",
    Interpret: "Előadó",
    "Set custom time": "Saját idő beállítása",
    "Create QR": "QR kód hozzáadása",
    Yes: "Igen",
    No: "Nem",
    "Stand text": "Szöveg a fa állványon",
    Place: "Hely",
    "Decorative Names": "Dekoratív Nevek",
    "Decorative Names + Date": "Dekoratív Nevek + Dátum",
    "Hearts + Names": "Szívek + Nevek",
    "Heart + Names": "Szív + Nevek",
    "Hearts + Names + Date": "Szívek + Nevek + Dátum",
    "Fullwidth image": "Teljes szélességű kép",
    "Actual time": "Kezdési idő",
    "End time": "Befejezési idő",
    PhotoLayout: "Elrendezés",
    Wedding: "Esküvő",
    "Drawn heart": "Rajzolt szív",
    "Triple hearts": "3 szív",
    shape_1: "Négyzet",
    shape_2: "Szív",
    shape_3: "Kör",
    "Oak massif": "Tölgy tömb",
    Packaging: "Csomagolás",
    base_packaging: "Alap csomagolás",
    gift_packaging: "Ajándék csomagolás",
    gift_dedication_packaging: "Ajándék dedikálás csomagolás",
    PhotoStyle: "Fénykép stílus",
    style_1: "Stílus 1",
    style_2: "Stílus 2",
    style_3: "Stílus 3",
    style_4: "Stílus 4",
    "Packaging text": "Szöveg a csomagoláson",
    Photo: "Kép",
    Image: "Kép",
    Images: "Képeket",
    "Choose layout": "Válasszon elrendezést",
    "Account name": "Fióknév",
    "Upload file": "Töltsd fel a fényképed",
    "It likes": "Kedvelte",
    others: "további",
    and: "és",
  },
  sk: {
    "Choose font type": "Vyberte štýl písma",
    "Sold capacity": "Výrobné kapacity sú pre tento rok naplnené.<br>Ďakujeme!",
    "How it works": "Ako to funguje",
    and: "a",
    PhotoStyle: "Štýl fotografie",
    style_1: "Štýl 1",
    style_2: "Štýl 2",
    style_3: "Štýl 3",
    style_4: "Štýl 4",
    ///
    Alright: "Dobre",
    illustration_popup_description_1:
      "Vašu fotografiu upravíme a prekreslíme do vybraného štýlu.",
    illustration_popup_description_2:
      "Prekreslenú fotografiu vám do 24 hodín od vytvorenia objednávky zašleme na kontrolu.",
    illustration_popup_description_3:
      "Po schválení kresby putuje sklenená tabuľka ihneď do výroby.",
    illustration_popup_title: "Editor ilustrácia",
    "Carefully check data":
      "Prosím, starostlivo si skontrolujte všetky zadané texty a dáta.",
    //
    "Packaging text": "Text na balení",
    Packaging: "Balenie",
    base_packaging: "Základné",
    gift_packaging: "Darčekové balenie",
    gift_dedication_packaging: "Darčekové balenie s venovaním",
    //
    "Oak massif": "Dubový masív",
    "Black oak massif": "Čierny dubový masív",
    "Brown oak massif": "Hnedý dubový masív",
    "Engraved oak massif": "Dubový masív s gravírovaním",
    "Engraved black oak massif": "Čierny dubový masív s gravírovaním",
    "Magnetic mounts": "Magnetické uchytenie na stenu",
    "Luminous oak massif": "Svietiaci dubový masív",

    // example
    Marvel: "SK Marvel",
    Nature: "SK Nature",
    Sky: "SK Sky",
    // end example
    layout_1: "1",
    layout_2: "2",
    layout_3: "3",
    layout_4: "4",
    layout_5: "5",
    shape_1: "Hranatý",
    shape_2: "Srdce",
    shape_3: "Okrúhly",
    Table: "Tabuľka",
    "Add stand to cart": "Pridať stojan do košíka",
    Quantity: "Počet",
    "Text for engraving": "Text na gravírovanie",
    "Stand size of table": "Veľkosť stojanu pre tabuľku",
    Image: "Obrázok",
    Images: "Obrázky",
    "Upload image": "Nahrajte fotografiu",
    "Uploaded image": "Nahraný obrázok",
    Original: "Pôvodná",
    Save: "Uložiť",
    Profile: "Profilová fotografia",
    "Upload profile image": "Nahrať profilovku",
    "Uploaded profile image": "Nahraná profilovka",
    "Account name": "Názov účtu",
    Description: "Popis",
    "Like it": "Páči sa to",
    "And others": "a ďalším",
    "Approved account": "Overený účet",
    "Liked photo": "Lajknutá fotka",
    "Active stories": "Aktívne stories",
    Yes: "Áno",
    No: "Nie",
    "Horizontal rotation": "Horizontálne otočenie",
    "Text on package": "text na balení (odporúčame)",
    White: "Biela",
    Black: "Čierna",
    Stand: "Stojan",
    LoverType: "Motív",
    LoverShape: "Útvar",
    FontType: "Štýl písma",
    PhotoLayout: "Rozloženie",
    "Stand text": "Text na stojane",
    "Stand text placeholder": "Text na drevenom stojane (max. {limit} znakov)",
    "No stand": "Bez stojanu",
    "Wooden stand": "Drevený stojan",
    "Engraved wooden stand": "Drevený stojan s gravírovaním",
    Date: "Dátum",
    Names: "Mená",
    "Names + Dates": "Mená + Dátum",
    Place: "Miesto",
    "Decorative Names": "Ozdobné Mená",
    "Decorative Names + Date": "Ozdobné Mená + Dátum",
    "Hearts + Names": "Srdiečka + Mená",
    "Heart + Names": "Srdiečko + Mená",
    "Hearts + Names + Date": "Srdiečka + Mená + Dátum",
    "Choose photo styles": "Vyberte štýl fotografie",
    "Choose template color": "Vyberte farbu šablóny",
    "Choose table size": "Vyberte veľkosť tabuľky",
    "Choose stand": "Vyberte príslušenstvo",
    "Choose theme": "Vyberte motív",
    "Choose shape": "Vyberte útvar",
    "Add table to cart": "Pridať do košíka",
    delivery_time:
      "{entity} odošleme do <strong>{hours} hodín</strong>, doprava <strong>ZADARMO</strong>.",
    max_upload: "Maximálna veľkosť obrázku je <strong>{limit}MB</strong>",
    product_description:
      "*Tabuľka bude vyrobená zo <strong>skla</strong>. Farebné pozadie slúži len pre jednoduchšiu editáciu. Náhľad je ilustračný. Prípadné nedostatky pred výrobou upravíme.",
    image_loading: "Nahrávam obrázok<br>Chvíľku to potrvá...",
    "Add text": "Pridajte text",
    "Primary text": "Hlavný text",
    "Secondary text": "Vedľajší text",
    "Add secondary text": "Pridať vedlajší text",
    "Add secondary text max": "Pridať vedlajší text (max. {limit} znakov)",
    "Set custom time": "Nastaviť vlastný čas",
    "Create QR": "Vytvoriť z play buttonu QR kód",
    "Song name": "Názov skladby",
    Interpret: "Interpret",
    "Type QR": "Zadajte adresu URL pre vytvorenie QR kódu",
    "Actual time": "Počiatočný čas",
    "End time": "Koncový čas",
    "QR link": "URL adresa pre QR",
    "It likes": "Páči sa to",
    others: "ďalším",
    "Choose layout": "Vyberte si rozloženie",
    "Upload photo": "Nahrajte fotografiu {number}",
    Photo: "Fotografia",
    /// /
    Wedding: "Svadobné",
    "Drawn heart": "Kreslené srdiečko",
    "Triple hearts": "3 srdiečka",
    "Black wooden stand": "Čierny drevený stojan",
    "Acryl stand": "Akrylový stojan",
    Delete: "Odstrániť",
    Edit: "Upraviť",
    Sold: "Vypredané",
    "Upload file": "Nahrať fotografiu",
    accessory_loading: "Vkladám príslušenstvo<br>do košíka",
    rotate_glass: "Otočiť tabuľku na šírku",
    set_fullwidth_glass: "Nastaviť obrázok na plnú šírku",
    "Fullwidth image": "Obrázok na plnú šírku",
    "Choose packaging": "Vyberte balenie",

    // NEWEST
    GiftVoucher: "Typ",
    "small+acrylic": "Malá plaketa + akrylový stojan",
    "small+oak": "Malá plaketa + dubový masív",
    "small+engraved": "Malá plaketa + dubový masív s gravírovaním",
    "small+luminous": "Malá plaketa + svietiaci RGB stojan",
  },
  cs: {
    "Choose font type": "Vyberte styl písma",
    "Sold capacity":
      "Výrobní kapacity jsou pro letošní rok naplněny.<br>Děkujeme!",
    "How it works": "Jak to funguje",
    and: "a",
    PhotoStyle: "Styl fotografie",
    style_1: "Styl 1",
    style_2: "Styl 2",
    style_3: "Styl 3",
    style_4: "Styl 4",
    Alright: "Dobře",
    illustration_popup_description_1:
      "Vaši fotografii upravíme a překreslíme do vybraného stylu.",
    illustration_popup_description_2:
      "Překreslenou fotografii vám do 24 hodin od vytvoření objednávky zašleme ke kontrole.",
    illustration_popup_description_3:
      "Po schválení kresby putuje skleněná tabulka ihned do výroby.",
    illustration_popup_title: "Editor ilustrace",
    "Carefully check data":
      "Prosím, pečlivě si zkontrolujte všechny zadané texty a data.",

    "Packaging text": "Text na balení",
    Packaging: "Balení",
    base_packaging: "Základní",
    gift_packaging: "Dárkové balení",
    gift_dedication_packaging: "Dárkové balení s věnováním",
    "Oak massif": "Dubový masiv",
    "Black oak massif": "Černý dubový masiv",
    "Brown oak massif": "Hnědý dubový masiv",
    "Engraved oak massif": "Dubový masiv s gravírováním",
    "Engraved black oak massif": "Černý dubový masiv s gravírováním",
    "Magnetic mounts": "Magnetické uchycení na zeď",
    "Luminous oak massif": "Svítící dubový stojánek",

    // example
    Marvel: "CZ Marvel",
    Nature: "CZ Nature",
    Sky: "CZ Sky",
    // end example
    layout_1: "1",
    layout_2: "2",
    layout_3: "3",
    layout_4: "4",
    layout_5: "5",
    shape_1: "Hranatý",
    shape_2: "Srdce",
    shape_3: "Kulatý",
    Table: "Desku",
    "Add stand to cart": "Přidat stojan do košíku",
    Quantity: "Počet",
    "Text for engraving": "Text na gravírování",
    "Stand size of table": "Velikost stojanu pro desku",
    Image: "Obrázek",
    Images: "Obrázky",
    Profile: "Profilová fotografie",
    "Uploaded profile image": "Nahraná profilovka",
    "Upload profile image": "Nahrajte profilovku",
    "Account name": "Název účtu",
    Description: "Popis",
    "Like it": "Líbí se to",
    "And others": "a dalším",
    "Approved account": "Ověřený účet",
    "Liked photo": "Lajknutá fotka",
    "Active stories": "Aktivní stories",
    Yes: "Ano",
    No: "Ne",
    "Horizontal rotation": "Horizontální otočení",
    "Text on package": "text na balení (doporučujeme)",
    "Upload image": "Nahrajte fotografii",
    "Uploaded image": "Nahraný obrázek",
    Original: "Původní",
    Save: "Uložit",
    White: "Bílá",
    Black: "Černá",
    Stand: "Stojan",
    LoverType: "Motiv",
    LoverShape: "Útvar",
    FontType: "Styl písma",
    PhotoLayout: "Rozložení",
    "Stand text": "Text na stojanu",
    "Stand text placeholder": "Text na dřevěném stojanu (max. {limit} znaků)",
    "No stand": "Bez stojanu",
    "Wooden stand": "Dřevěný stojan",
    "Engraved wooden stand": "Dřevěný stojan s gravírováním",
    Date: "Datum",
    Names: "Jména",
    "Names + Dates": "Jména + Datum",
    Place: "Místo",
    "Decorative Names": "Ozdobné Jména",
    "Decorative Names + Date": "Ozdobné Jména + Datum",
    "Hearts + Names": "Srdíčka + Jména",
    "Heart + Names": "Srdíčko + Jména",
    "Hearts + Names + Date": "Srdíčka + Jména + Datum",
    font_type_1: "Montserrat",
    font_type_2: "Sour Gummy",
    font_type_3: "Caveat",
    "Choose photo styles": "Vyberte styl fotografie",
    "Choose template color": "Vyberte barvu šablony",
    "Choose table size": "Vyberte velikost desky",
    "Choose stand": "Vyberte příslušenství",
    "Choose theme": "Vyberte motiv",
    "Choose shape": "Vyberte útvar",
    "Add table to cart": "Přidat do košíku",
    delivery_time:
      "{entity} odešleme do <strong>{hours} hodin</strong>, doprava <strong>ZDARMA</strong>.",
    max_upload: "Maximální velikost obrázku je <strong>{limit}MB</strong>",
    product_description:
      "*Deska bude vyrobena ze <strong>skla</strong>. Barevné pozadí slouží pouze pro jednodušší editaci. Náhled je ilustrační. Případné nedostatky před výrobou upravíme.",
    image_loading: "Nahrávám obrázek<br>Chvilku to potrvá...",
    "Add text": "Přidejte text",
    "Primary text": "Hlavní text",
    "Secondary text": "Vedlejší text",
    "Add secondary text": "Přidat vedlejší text",
    "Add secondary text max": "Přidat vedlejší text (max. {limit} znaků)",
    "Set custom time": "Nastavit vlastní čas",
    "Create QR": "Vytvořit z play buttonu QR kód",
    "Song name": "Název skladby",
    Interpret: "Interpret",
    "Type QR": "Zadejte adresu URL pro vytvoření QR kódu",
    "Actual time": "Počáteční čas",
    "End time": "Koncový čas",
    "QR link": "URL adresa pro QR",
    "It likes": "To se líbi",
    others: "dalším",
    "Choose layout": "Vyberte si rozložení",
    "Upload photo": "Nahrajte fotografii {number}",
    Photo: "Fotografie",
    /// /
    Wedding: "Svatební",
    "Drawn heart": "Kreslené srdíčko",
    "Triple hearts": "3 srdíčka",
    "Black wooden stand": "Černý dřevěný stojan",
    "Acryl stand": "Akrylový stojánek",
    Delete: "Odstranit",
    Edit: "Upravit",
    Sold: "Vyprodáno",
    "Upload file": "Nahrát fotografii",
    accessory_loading: "Vkládám příslušenství<br>do košíku",
    rotate_glass: "Otočit tabulku na šířku",
    set_fullwidth_glass: "Nastavit obrázek na plnou šířku",
    "Fullwidth image": "Obrázek na plnou šířku",
    "Choose packaging": "Vyberte balení",

    // NEWEST
    GiftVoucher: "Typ",
    "small+acrylic": "Malá plaketa + akrylový stojan",
    "small+oak": "Malá plaketa + dubový masiv",
    "small+engraved": "Malá plaketa + dubový masiv s gravírováním",
    "small+luminous": "Malá plaketa + svítící RGB stojan",
  },
};

export default product;
